import styled from 'styled-components/macro'

import { Container } from 'components/container'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const StyledFooter = styled.footer`
  margin: var(--grid-size) 0 0;
  padding: 3rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 1.6rem;

  ${mq.medium} {
    padding: 6rem 0;
  }

  ${Container} {
    display: flex;
    flex-direction: column;

    ${mq.extraLarge} {
      --col-size: calc(4 * var(--grid-size) + 3 * var(--gap-size));

      display: grid;
      grid-template-columns: var(--col-size) var(--col-size) 1fr;
      gap: 0 calc(var(--grid-size) + 2 * var(--gap-size));
      grid-template-areas: 'about authors social' 'copy copy copy';

      [data-about] {
        grid-area: about;
      }

      [data-authors] {
        grid-area: authors;
      }

      [data-social] {
        grid-area: social;
      }

      [data-copy] {
        text-align: right;
        grid-area: copy;
      }
    }

    > div {
      flex-grow: 2;

      &:last-child {
        flex-grow: 1;
      }
    }
  }

  p {
    opacity: 0.8;
  }
  
  a {
    color: white;
    text-decoration: underline;
  }
`

export const Title = styled.h2`
  margin: 2.4rem 0 1.4rem;
  font-size: 1.8rem;
  text-transform: uppercase;
  font-family: ${theme.fonts.headings};
  font-weight: normal;
`

export const FollowUs = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 -0.3em;
  font-size: 4rem;

  svg {
    display: block;
  }

  li {
    display: inline-block;
    margin-right: 0.3em;
  }

  a {
    color: inherit;
  }
`
